import React from 'react';
import { MessageSquare, Plus, Calendar, Clock, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useTenant } from './TenantContext';

const TenantRequests = () => {
  const { requests, formatDate, statusLabels, requestTypeLabels, priorityLabels, setIsRequestDialogOpen, handleViewRequest } = useTenant();
  return (
    <>
  <Card>
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle className="text-lg">Mes Demandes</CardTitle>
      <Button 
        onClick={() => setIsRequestDialogOpen(true)}
        className="bg-[#1B3A4B] hover:bg-[#142D3A]"
        data-testid="new-request-btn"
      >
        <Plus className="w-4 h-4 mr-2" />
        Nouvelle demande
      </Button>
    </CardHeader>
    <CardContent>
      {requests.length > 0 ? (
        <div className="space-y-3">
          {requests.map((request) => {
            const StatusIcon = statusLabels[request.status]?.icon || Clock;
            return (
              <div
                key={request.id}
                className="p-4 rounded-lg border border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors"
                onClick={() => handleViewRequest(request)}
                data-testid={`request-item-${request.id}`}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Badge className={priorityLabels[request.priority]?.color}>
                      {priorityLabels[request.priority]?.label}
                    </Badge>
                    <Badge variant="outline">
                      {requestTypeLabels[request.request_type]}
                    </Badge>
                  </div>
                  <Badge className={statusLabels[request.status]?.color}>
                    <StatusIcon className="w-3 h-3 mr-1" />
                    {statusLabels[request.status]?.label}
                  </Badge>
                </div>
                
                <h4 className="font-medium text-gray-900 mb-1">
                  {request.subject}
                </h4>
                <p className="text-sm text-gray-500 line-clamp-2">
                  {request.description}
                </p>
                
                <div className="flex items-center justify-between mt-3">
                  <span className="text-xs font-mono text-gray-400">
                    {request.request_number}
                  </span>
                  <span className="text-xs text-gray-500">
                    {formatDate(request.created_at)}
                  </span>
                </div>
                
                {request.response && (
                  <div className="mt-3 p-3 bg-blue-50 rounded-lg">
                    <p className="text-xs font-medium text-blue-800 mb-1">Réponse:</p>
                    <p className="text-sm text-blue-700">{request.response}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8">
          <MessageSquare className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p className="text-gray-500 mb-4">Aucune demande pour le moment</p>
          <Button 
            onClick={() => setIsRequestDialogOpen(true)}
            variant="outline"
          >
            <Plus className="w-4 h-4 mr-2" />
            Créer une demande
          </Button>
        </div>
      )}
    </CardContent>
  </Card>
    </>
  );
};

export default TenantRequests;
